import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar';
import { AdminSidebar } from './AdminSidebar';

interface AdminLayoutProps {
  children: ReactNode;
}

const PAGE_TITLES: Record<string, string> = {
  '/a12o': 'Dashboard',
  '/a12o/tenants': 'Tenants',
  '/a12o/assinaturas': 'Assinaturas',
  '/a12o/financeiro': 'Financeiro',
};

export function AdminLayout({ children }: AdminLayoutProps) {
  const location = useLocation();
  const pageTitle = PAGE_TITLES[location.pathname] || 'Admin';

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full">
        <AdminSidebar />
        <main className="flex-1 overflow-auto">
          <header className="sticky top-0 z-10 flex h-14 items-center gap-4 border-b border-border/20 bg-background px-6">
            <SidebarTrigger />
            <h1 className="text-sm font-semibold">{pageTitle}</h1>
          </header>
          <div className="animate-in fade-in duration-200 p-6 lg:p-8">
            {children}
          </div>
        </main>
      </div>
    </SidebarProvider>
  );
}
